export class ContentCookieDetails {
  id: any;
  alertMessage: any;
  countryList: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['alertMessage']) {
        this.alertMessage = contentjson['alertMessage'];
      }
      if (contentjson['countryList']) {
        this.countryList = contentjson['countryList'];
      }
    } else {
      this.id = null;
      this.alertMessage = null;
      this.countryList = null;
    }
  }
}
